// packages block
import ReactDropzone from "react-dropzone";
import { useTranslation } from "react-i18next";
import React, { useEffect, useReducer, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AddCircleIcon from "@material-ui/icons/AddCircleOutline";
// common block
import "./style.css";
import { FormButton } from "../../../../components/form";
import { SearchInput } from "../../../../components/form/searchInput";
// constants, theme, utils and api block
import { BLUE_EIGHT, ORANGE_TWO, WHITE } from "../../../../theme";
import { Box, CircularProgress, makeStyles } from "@material-ui/core";
import { setAlert } from "../../../../redux/reducers/alert";
import {
  BASE_URL,
  CHECK_SCHOOL_SYNC_ERP_STATUS,
  SYNC_ERP_STUDENTS,
} from "../../../../util/constants";
import axios from "axios";
import { setLoadingForAllSyncButtons } from "../../../../redux/reducers/allSyncButtonsLoader";
import { Button } from "react-bootstrap";

const useStyles = makeStyles(() => ({
  formControl: {
    height: 35,
    minWidth: 150,
  },
  buttonBackground: {
    width: "10vw",
    color: WHITE,
    backgroundColor: BLUE_EIGHT,
    border: `1px solid ${BLUE_EIGHT}`,
    borderRadius: 15,
    height: 40,
  },
}));

export const TableHeader = ({
  handleAdd,
  handleSearching,
  handleOpenDeleteDialog,
  selectedIds,
  handleupdateMultipleStudents = () => {},
  handleUpdate,
}) => {
  const classes = useStyles();
  const [file, setFile] = useState(null);
  const { schoolId, erpSchoolExists } = useSelector((state) => state.user);
  const { allSyncButtonsLoader } = useSelector(
    (state) => state.loadingForAllSyncButtons
  );

  const dispatch = useDispatch();

  const showErrorAlert = (message) => {
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };

  const showSuccessAlert = (message) => {
    dispatch(
      setAlert({
        severity: "success",
        message,
        show: true,
      })
    );
  };

  const syncErpStudents = async () => {
    dispatch(setLoadingForAllSyncButtons({ allSyncButtonsLoader: true }));

    try {
      const response = await axios.get(
        BASE_URL + "/" + SYNC_ERP_STUDENTS + `?schoolId=${schoolId}`
      );
      if (response.status === 200) {
        showSuccessAlert("Students synced successfully");
        dispatch(setLoadingForAllSyncButtons({ allSyncButtonsLoader: false }));

        window.location.reload();
      }
    } catch (error) {
      console.error(error);
      showErrorAlert("Failed to sync students");
      dispatch(setLoadingForAllSyncButtons({ allSyncButtonsLoader: false }));
    }
  };

  useEffect(() => {
    axios
      .get(
        BASE_URL + "/" + CHECK_SCHOOL_SYNC_ERP_STATUS + `?schoolId=${schoolId}`
      )
      .then((res) => {
        dispatch(
          setLoadingForAllSyncButtons({
            allSyncButtonsLoader: Boolean(res.data.isProcessing),
          })
        );
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }, []);

  const [{ search, searchError }, setData] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      search: "",
      searchError: false,
    }
  );
  const [loading, setLoading] = useState(false);

  const { token, role } = useSelector((state) => state.user);
  let local = JSON.parse(localStorage.getItem("notify"));
  local = local || [];
  const { t } = useTranslation();

  const handleChange = (prop) => (event) => {
    handleSearching(event.target.value);
    setData({
      [prop]: event.target.value,
      searchError: false,
    });
  };

  const handleUpload = async (file) => {
    if (file.type == "application/vnd.ms-excel") {
      handleupdateMultipleStudents(file);
    } else {
      handleupdateMultipleStudents(file);
    }
  };

  const uploadFile = (acceptedFiles) => {
    let fileSize = acceptedFiles[0].size / 1024 / 1024;
    if (fileSize < 10) {
      if (acceptedFiles.length > 0) {
        handleUpload(acceptedFiles[0]);
      }
    } else {
      showErrorAlert("Your CSV must be 10MB or greater than 10MB, Try again");
    }
  };

  return (
    <div className="table-header student-popup">
      <div className="left-column">
        <div className="student_SearchBar">
          <SearchInput
            searchIcon={true}
            error={searchError}
            value={search}
            onChange={handleChange}
            label={t("text_search_by_student_id_or_student_name")}
            name="search"
            height={40}
          />
        </div>
      </div>

      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <FormButton
          width={"10vw"}
          height={40}
          borderColor={ORANGE_TWO}
          titleColor={WHITE}
          hoverTitleColor={ORANGE_TWO}
          hoverBorderColor={ORANGE_TWO}
          backgroundColor={ORANGE_TWO}
          hoverBackgroundColor={WHITE}
          borderTopRightRadius={15}
          borderTopLeftRadius={15}
          borderBottomLeftRadius={15}
          borderBottomRightRadius={15}
          title={t("text_delete")}
          style={{
            textTransform: "none",
            fontSize: "0.8vw",
            fontWeight: "700",
          }}
          disabled={true}
          overRideButtonCheck={!selectedIds.length > 0}
          onClickHandler={handleOpenDeleteDialog}
          loading={loading}
          loadingColor={ORANGE_TWO}
        />

        <div>
          <FormButton
            width={"10vw"}
            height={40}
            borderColor={BLUE_EIGHT}
            titleColor={BLUE_EIGHT}
            hoverTitleColor={WHITE}
            hoverBorderColor={BLUE_EIGHT}
            backgroundColor={WHITE}
            hoverBackgroundColor={BLUE_EIGHT}
            borderTopRightRadius={15}
            borderTopLeftRadius={15}
            borderBottomLeftRadius={15}
            borderBottomRightRadius={15}
            title={t("text_add_student")}
            style={{
              textTransform: "none",
              fontSize: "0.8vw",
              fontWeight: "700",
              padding: 0,
            }}
            onClickHandler={handleAdd}
            startIcon={<AddCircleIcon color="inherit" />}
            disabled={true}
            overRideButtonCheck={role === "manager" ? false : true}
            loading={allSyncButtonsLoader}
            loaderText={`${t("text_syncing")}...`}
          />
        </div>
        {erpSchoolExists ? (
          <div>
            <FormButton
              width={"10vw"}
              height={40}
              borderColor={BLUE_EIGHT}
              titleColor={BLUE_EIGHT}
              hoverTitleColor={WHITE}
              hoverBorderColor={BLUE_EIGHT}
              backgroundColor={WHITE}
              hoverBackgroundColor={BLUE_EIGHT}
              borderTopRightRadius={15}
              borderTopLeftRadius={15}
              borderBottomLeftRadius={15}
              borderBottomRightRadius={15}
              title={t("text_sync_students")}
              style={{
                textTransform: "none",
                fontSize: "0.8vw",
                fontWeight: "700",
                padding: 0,
              }}
              onClickHandler={() => syncErpStudents()}
              disabled={true}
              overRideButtonCheck={role === "manager" ? false : true}
              loading={allSyncButtonsLoader}
              loaderText={`${t("text_syncing")}...`}
            />
          </div>
        ) : role === "manager" ? (
          <div>
            <ReactDropzone onDrop={uploadFile} multiple={false}>
              {({ getRootProps, getInputProps }) => (
                <section>
                  <div {...getRootProps()}>
                    <input {...getInputProps()} accept=".csv" />
                    {file === null && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {allSyncButtonsLoader ? (
                          <Button
                            // disabled={true}
                            onClick={(event) => {
                              event.stopPropagation();
                            }}
                            className={classes.buttonBackground}
                            variant="outlined"
                          >
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              width="100%"
                              height="100%"
                            >
                              <CircularProgress
                                size={20}
                                sx={{ color: "white", mx: 1 }}
                              />
                              <span
                                style={{
                                  color: "white",
                                  textTransform: "capitalize",
                                }}
                              >
                                {`${t("text_syncing")}...`}
                              </span>
                            </Box>
                          </Button>
                        ) : (
                          <div className={classes.csvDetail}>
                            <div
                              className="update-bulk-student"
                              onClick={(event) => handleUpdate(event)}
                            >
                              {"Update Students"}
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </section>
              )}
            </ReactDropzone>
          </div>
        ) : null}
      </div>
    </div>
  );
};
